// src/pages/OtherIngredients.js
import React from 'react';
import ProductCategoryTemplate from '../components/templet/ProductCategoryTemplate';
import image2 from '../assets/images/product/image-2.jpg';
import image3 from '../assets/images/product/image-3.jpg';
import image4 from '../assets/images/product/image-4.jpg';
import image5 from '../assets/images/product/image-5.jpg';
import image6 from '../assets/images/product/image-6.jpg';
import image7 from '../assets/images/product/image-7.jpg';
import image8 from '../assets/images/product/image-8.jpg';
import image9 from '../assets/images/product/image-9.jpg';
import other from '../assets/images/category/other ingriedient.jpg';

const OtherIngredients = () => {
  const products = [
    {
      name: "Lock In Moisture, Boost Texture",
      category: "STARCHES & GUMS",
      description: "Modified starches and hydrocolloids for superior moisture retention and texture control. Essential ingredients for maintaining product quality and extending shelf-life.",
      features: [
        "Modified Corn Starch (E1422) : Cold-water soluble starch for improved viscosity and stability",
        "Tapioca Starch (Native & Modified) : Clean-label thickening and binding agent",
        "Potato Starch : Excellent water-holding capacity for moist products",
        "Rice Starch : Gluten-free alternative with neutral taste profile"
      ],
      image: "/assets/images/starches.jpg"
    },
    {
      name: "Consistency That Performs",
      category: "HYDROCOLLOIDS",
      description: "Premium hydrocolloid systems for texture control, stability, and moisture management. From guar gum to carrageenan, we have solutions for every application.",
      features: [
        "Xanthan Gum (E415) : Superior thickening and stabilizing properties",
        "Guar Gum (E412) : Cost-effective viscosity builder and moisture retention",
        "CMC (Carboxymethyl Cellulose) : Excellent water-binding and texturizing agent",
        "Modified Cellulose : Provides structure and improved mouthfeel"
      ],
      image: "/assets/images/hydrocolloids.jpg"
    },
    {
      name: "Lock In Freshness, Naturally",
      category: "NATURAL INGREDIENTS",
      description: "Natural ingredient solutions for clean-label formulations. Maintain freshness and quality without artificial additives.",
      features: [
        "Vinegar Powder : Natural acidulant and preservative for extended shelf-life",
        "Vital Wheat Gluten : Strengthens dough structure and improves volume",
        "Wheat Fiber : Adds fiber content while maintaining texture",
        "Inulin : Prebiotic fiber for health benefits and texture improvement"
      ],
      image: "/assets/images/natural-ingredients.jpg"
    },
    {
      name: "Elevate Every Bite With Bold, Authentic Flavor",
      category: "FLAVORS & COLORS",
      description: "Premium flavoring systems and natural colors to make your products stand out. From vanilla to chocolate, butter to fruit flavors.",
      features: [
        "Vanilla Flavors : Natural and nature-identical vanilla for authentic taste",
        "Chocolate Flavors : Rich cocoa profiles for premium chocolate products",
        "Butter Flavors : Creamy, authentic butter taste without refrigeration",
        "Fruit Flavors : Wide range of fruit profiles for various applications"
      ],
      image: "/assets/images/flavors.jpg"
    }
  ];

  const relatedCategories = [
    {
      title: "Bread Improvers & Dough Conditioners",
      description: "Core bread improvement.",
      itemCount: 12,
      image: image2,
      link: "/products/bread-improvers"
    },
    {
      title: "Premixes & Concentrates",
      description: "Complete solutions.",
      itemCount: 14,
      image: image3,
      link: "/products/premixes"
    },
    {
      title: "Shelf-Life Enhancers & Preservatives",
      description: "Extended freshness.",
      itemCount: 10,
      image: image4,
      link: "/products/shelf-life"
    },
    {
      title: "Emulsifiers & Texture Improvers",
      description: "Texture solutions.",
      itemCount: 8,
      image: image5,
      link: "/products/emulsifiers"
    },
    {
      title: "Leavening Agents (Raising Agents)",
      description: "Rise solutions.",
      itemCount: 13,
      image: image6,
      link: "/products/leavening"
    },
    {
      title: "Specialty Enzymes",
      description: "Natural improvers.",
      itemCount: 17,
      image: image7,
      link: "/products/enzymes"
    },
    {
      title: "Quality Assurance",
      description: "Quality guarantee.",
      itemCount: null,
      image: image8,
      link: "/quality"
    },
    {
      title: "View All",
      description: "Browse all.",
      itemCount: null,
      image: image9,
      link: "/products"
    }
  ];

  return (
    <ProductCategoryTemplate
      title="Other Ingredients: Starches, Gums, Flavors, etc."
      description="The finishing touch—functional bakery ingredients that enhance texture, flavor, and shelf-stability. Complete your formulations with our comprehensive range of specialty ingredients."
      heroImage={other}
      products={products}
      relatedCategories={relatedCategories}
    />
  );
};

export default OtherIngredients;